var map = {
	"./contacto/contacto.module": [
		"./src/app/contacto/contacto.module.ts",
		"default~contacto-contacto-module~home-home-module~transfers-transfers-module",
		"default~contacto-contacto-module~transfers-transfers-module",
		"contacto-contacto-module"
	],
	"./destinos/destinos.module": [
		"./src/app/destinos/destinos.module.ts",
		"destinos-destinos-module"
	],
	"./galeria/galeria.module": [
		"./src/app/galeria/galeria.module.ts",
		"galeria-galeria-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"default~contacto-contacto-module~home-home-module~transfers-transfers-module",
		"default~home-home-module~transfers-transfers-module",
		"home-home-module"
	],
	"./nosotros/nosotros.module": [
		"./src/app/nosotros/nosotros.module.ts",
		"nosotros-nosotros-module"
	],
	"./tours/tours.module": [
		"./src/app/tours/tours.module.ts",
		"tours-tours-module"
	],
	"./transfers/transfers.module": [
		"./src/app/transfers/transfers.module.ts",
		"default~contacto-contacto-module~home-home-module~transfers-transfers-module",
		"default~home-home-module~transfers-transfers-module",
		"default~contacto-contacto-module~transfers-transfers-module",
		"transfers-transfers-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;